<template>
  <!-- 栏目列表 -->
  <div class="vue">
    <div class="header flex flexAi-c">
      <div class="text">栏目列表</div>
      <a-button @click="addColumnBut" round type="primary" size="small"
        >添加栏目</a-button
      >
    </div>
    <div class="content ">
      <a-table
        rowKey="id"
        :columns="columns"
        :scroll="{ y: 400 }"
        :pagination="false"
        :data-source="AdminList"
        childrenColumnName="list"
      >
        <template
          v-for="col in ['sequence', 'name', 'url']"
          :slot="col"
          slot-scope="text, record, index"
        >
          <div :key="col">
            <a-input
              v-if="
                (record.editable && col == 'name') ||
                  (record.editable && col == 'sequence') ||
                  (record.editable && col == 'url')
              "
              style="margin: -5px 0"
              :value="text"
              @change="e => handleChange(e.target.value, record, col, index)"
            />

            <template v-else>
              {{ text }}
            </template>
          </div>
        </template>
        <template
          slot="operation"
          slot-scope="text, record, index, newindex, yy"
        >
          <div class="operation flex">
            <div class="editable-row-operations">
              <span class="operation-span" v-if="record.editable">
                <a class="sure" @click="() => save(record, index)">确认</a>
                <a class="operation-cancel" @click="() => cancel(record, index)"
                  >取消</a
                >
              </span>
              <span v-else>
                <a
                  style="padding-right:10px"
                  :disabled="editingKey !== ''"
                  @click="() => edit(record, index, newindex, yy)"
                  >编辑</a
                >
              </span>
            </div>
            <div class="editable-row-operations">
              <a-popconfirm
                v-if="!record.editable"
                ok-text="是"
                cancel-text="否"
                title="确定要删除此条数据吗?"
                @confirm="() => onDelete(record)"
              >
                <a
                  class="remove"
                  :disabled="editingKey !== ''"
                  href="javascript:;"
                  >删除</a
                >
              </a-popconfirm>
            </div>
          </div>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  props: [''],
  data() {
    return {
      AdminList: [],
      // 表格名称
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          scopedSlots: { customRender: 'id' }
        },
        {
          title: '序号（0最靠前）',
          dataIndex: 'sequence',
          scopedSlots: { customRender: 'sequence' }
        },
        {
          title: '栏目名',
          dataIndex: 'name',
          scopedSlots: { customRender: 'name' }
        },
        {
          title: '栏目等级',
          dataIndex: 'parentId',
          customRender: text => {
            return text === 0 || text === null ? '一级栏目' : '二级栏目'
          }
        },
        {
          title: '页面路径',
          dataIndex: 'url',
          scopedSlots: { customRender: 'url' }
        },
        {
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      editingKey: '',
      page: '1', // 页数
      dialogAdmin: false,
      dialogTitle: '',
      isEdit: false, // 判断是否为修改管理员
      adId: '', // 管理员id
      adminForm: {
        name: '',
        tel: '',
        Password: '',
        activate: 0
      },
      adminFormEmail: '',
      adminFormList: ['姓名不能为空！', '手机账号不能为空！', '密码不能为空！']
    }
  },

  components: {},

  computed: {},

  beforeMount() {},

  mounted() {
    this.NavigationFindAll()
  },

  methods: {
    // 新增栏目
    addColumnBut() {
      this.$router.push({
        path: '/backstageIndex/addColumn'
      })
    },
    // 列表删除
    onDelete(row) {
      this.$postAxios('/navigation/removeNavigation', {
        id: row.id
      }).then(res => {
        if (res.status === '0') {
          this.$message.success(res.msg)
          this.NavigationFindAll()
        }
      })
    },

    // 编辑时 input 框返回值
    handleChange(value, record, column, index) {
      console.log(value)
      console.log(record)
      console.log(column)
      // 用来判断是父类还是子类
      if (record.parentId === null) {
        const target = this.AdminList.filter(item => record.id === item.id)[0]
        if (target) {
          target[column] = value
          this.$forceUpdate()
        }
      } else if (record.parentId !== null) {
        var indexnew = this.AdminList.map(item => item.id).indexOf(
          record.parentId
        )
        console.log(indexnew)
        const target = this.AdminList[indexnew].list.filter(
          item => record.id === item.id
        )[0]
        console.log(target)
        if (target) {
          target[column] = value
          this.$forceUpdate()
        }
      }
    },

    selectChange(e) {
      console.log(e)
    },
    // 表格编辑
    edit(record, index, x, y) {
      console.log(record)
      console.log(index)
      if (record.parentId === null) {
        const target = this.AdminList.filter(item => record.id === item.id)[0]
        console.log(target)
        this.editingKey = record.id
        if (target) {
          target.editable = true
          this.$forceUpdate() // 页面强制渲染
        }
      } else if (record.parentId !== null) {
        var indexnew = this.AdminList.map(item => item.id).indexOf(
          record.parentId
        )
        console.log(indexnew)

        const target = this.AdminList[indexnew].list.filter(
          item => record.id === item.id
        )[0]
        console.log(target)
        this.editingKey = record.id
        if (target) {
          target.editable = true
          this.$forceUpdate()
        }
      }
    },
    // 表格编辑时-确定
    save(record) {
      this.$postAxios('/navigation/addNavigation', {
        id: record.id,
        name: record.name,
        url: record.url,
        parentId: record.parentId,
        sequence: record.sequence
      }).then(res => {
        this.editingKey = ''
        if (record.parentId === null) {
          this.$message.success(res.msg)
          const target = this.AdminList.filter(item => record.id === item.id)[0]
          console.log(target)
          if (target) {
            target.editable = false
            this.$forceUpdate()
          }
        } else if (record.parentId !== null) {
          var indexnew = this.AdminList.map(item => item.id).indexOf(
            record.parentId
          )
          console.log(indexnew)
          const target = this.AdminList[indexnew].list.filter(
            item => record.id === item.id
          )[0]
          console.log(target)
          if (target) {
            target.editable = false
            this.$forceUpdate()
          }
        }
      })
    },
    // 表格编辑时-取消
    cancel(record, index) {
      this.editingKey = ''
      if (record.parentId === null) {
        const target = this.AdminList.filter(item => record.id === item.id)[0]
        console.log(target)
        if (target) {
          target.editable = false
          this.$forceUpdate()
        }
      } else if (record.parentId !== null) {
        this.editingKey = ''
        var indexnew = this.AdminList.map(item => item.id).indexOf(
          record.parentId
        )
        console.log(indexnew)
        const target = this.AdminList[indexnew].list.filter(
          item => record.id === item.id
        )[0]
        console.log(target)
        if (target) {
          target.editable = false
          this.$forceUpdate()
        }
      }
    },

    // 弹窗：新增/修改管理员确定
    dialogAdminBut() {
      if (!this.dialogAdmin) {
        if (!objNaN(this.adminForm, this.adminFormList)) {
        }
      } else if (this.dialogAdmin) {
        switch (true) {
          case !this.adminForm.name:
            this.$message.error('名字不能为空！')
            break
          case !this.adminForm.tel:
            this.$message.error('手机号不能为空！')
            break
          default:
        }
      }
    },

    // 弹窗关闭回调
    dialogAdminClose(e) {
      this.dialogAdmin = false
      this.isEdit = false
      this.adminForm = {
        name: '',
        tel: '',
        Password: '',
        activate: 0
      }
      this.adminFormEmail = ''
    },
    // 分页
    handleCurrentChange(val) {
      this.page = val
      console.log(`当前页: ${val}`)
      this.GetAdminList()
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    /* 接口 */
    // 获取列表
    NavigationFindAll() {
      this.$postAxios('/navigation/findAll').then(res => {
        if (res.status === '0') {
          this.AdminList = res.data
        }
      })
    }
  },

  watch: {}
}
</script>
<style lang="scss" scoped>
$colorMajor: #2b9dcf;
.flex {
  display: flex;
}
.FZ0875 {
  font-size: 0.875em;
}
.textalignLeft {
  text-align: left;
}
.vue {
  height: 100%;
  padding: 10px;
  background-color: #fff;
  border-left: 2px solid $colorMajor;
  .header {
    justify-content: space-between;
    height: 40px;
    .text {
      text-align: left;
      // font-size: 0.875em;
      color: $colorMajor;
      padding: 10px 5px;
    }
  }
  .content {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: calc(100% - 40px);
    /deep/ .ant-table-body {
      max-height: calc(100vh - 210px) !important;
      // height: calc(100vh - 110px);
      .ant-table-tbody {
        .operation {
          /deep/ .editable-row-operations {
            padding: 0 5px;
            .remove {
              color: red;
            }
            .operation-span {
              .sure {
                color: #0091ff;

                padding-right: 5px;
              }
              .operation-cancel {
                color: #ff5252;
              }
            }
          }
        }
      }
    }
  }
}
</style>
